import React from "react";
import { motion } from "framer-motion";
import { Phone, MessageCircle, Menu, X } from "lucide-react";
import LogoMark from "./Logo";

const NAV = [
  { label: "Inicio", href: "#inicio" },
  { label: "Servicios", href: "#servicios" },
  { label: "Zona", href: "#zona" },
  { label: "Tarifas", href: "#tarifario" },
  { label: "Galería", href: "#galeria" },
  { label: "Sobre mí", href: "#sobre" },
  { label: "Contacto", href: "#contacto" },
];

export default function Header() {
  const [open, setOpen] = React.useState(false);

  return (
    <header
      data-testid="site-header"
      className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-[#0A0D14]/70 border-b border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 lg:h-20 flex items-center justify-between">
        <a
          href="#inicio"
          data-testid="header-logo"
          className="flex items-center gap-3 group"
        >
          <LogoMark size={40} className="group-hover:scale-105 transition-transform" />
          <div className="leading-none">
            <div className="font-display text-[15px] tracking-tight text-white">INELÉCTRICAS</div>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-7">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              data-testid={`nav-${n.label.toLowerCase().replace(/[^a-z]/g, "-")}`}
              className="text-sm text-[#9CA3AF] hover:text-white transition-colors relative"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-2">
          <a
            href="tel:+34617420491"
            data-testid="header-call-btn"
            className="btn-ghost-cyan text-sm"
          >
            <Phone size={15} strokeWidth={2.2} />
            <span className="hidden lg:inline">617 420 491</span>
            <span className="lg:hidden">Llamar</span>
          </a>
          <a
            href="#contacto"
            data-testid="header-cta-presupuesto"
            className="btn-copper text-sm"
          >
            <MessageCircle size={15} strokeWidth={2.4} />
            Solicita presupuesto
          </a>
        </div>

        <button
          onClick={() => setOpen((v) => !v)}
          data-testid="mobile-menu-toggle"
          aria-label="Menu"
          className="md:hidden inline-flex items-center justify-center h-10 w-10 rounded-lg border border-white/10 text-white"
        >
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
      </div>

      {open && (
        <motion.div
          initial={{ opacity: 0, y: -8 }}
          animate={{ opacity: 1, y: 0 }}
          className="md:hidden border-t border-white/5 bg-[#0A0D14]/95 backdrop-blur-xl"
          data-testid="mobile-menu"
        >
          <div className="px-6 py-5 flex flex-col gap-3">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                className="text-[15px] text-white/90 py-1"
              >
                {n.label}
              </a>
            ))}
            <div className="flex gap-2 pt-3">
              <a href="tel:+34617420491" className="btn-ghost-cyan flex-1 justify-center text-sm">
                <Phone size={15} /> Llamar
              </a>
              <a href="#contacto" onClick={() => setOpen(false)} className="btn-copper flex-1 justify-center text-sm">
                Presupuesto
              </a>
            </div>
          </div>
        </motion.div>
      )}
    </header>
  );
}
